module.exports = __webpack_public_path__ + "img/team4.33cf6db9.webp";